module.exports = __webpack_public_path__ + "static/media/checkbox-green.872360e7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/form/FormCheckbox/checkbox-green.png
 ** module id = 1322
 ** module chunks = 0
 **/